<template>
  <el-dialog
    title="Отклик на заявку"
    :visible="visible"
    width="95%"
    @close="beforeClose"
  >
    <div class="da_mob">
      <el-collapse-transition>
        <section v-if="auto_selected" style="padding-bottom: 20px !important">
          <el-row>
            <el-col :span="12">
              <span>Выберите авто</span>
            </el-col>
            <el-col :span="12">
              <el-input
                v-model="search_auto"
                size="mini"
                placeholder="Введите для поиска"
                @input="filteredAutoList"
              />
            </el-col>
          </el-row>
          <el-table
            v-if="isAutoLoading"
            v-loading="isAutoLoading"
            :data="autos"
          />
          <template v-else>
            <el-row v-for="auto in autos" :key="auto.id" :gutter="10">
              <el-col :span="17">
                <p>АВТО / ПРИЦЕП:</p>
                <p>
                  <b>
                    {{ auto.state_numbers }} /
                    {{ auto.state_numbers_trailer }}
                  </b>
                </p>
              </el-col>
              <el-col :span="7">
                <el-button size="mini" @click="handleSelect('auto', auto)">
                  Выбрать
                </el-button>
              </el-col>
            </el-row>
            <div v-if="!autos.length">
              <p style="color: red">
                <b>Нет автомобилей доступных для выбора. </b><br />
                <b>Добавьте автомобиль. </b>
              </p>
              <el-button
                v-if="!autos.length"
                size="small"
                type="primary"
                @click="$router.push({ path: '/auto-add-mobile' })"
              >
                Добавить авто
              </el-button>
            </div>
          </template>
        </section>
      </el-collapse-transition>
      <el-collapse-transition>
        <section
          v-if="dispather_selected"
          style="padding-bottom: 20px !important"
        >
          <span>Вы выбрали авто: {{ selected_auto }}</span>
          <el-row>
            <el-col :span="12">
              <span>Выберите водителя</span>
            </el-col>
            <el-col :span="12">
              <el-input
                v-model="search_driver"
                size="mini"
                placeholder="Введите для поиска"
                @input="filteredDriverList"
              />
            </el-col>
          </el-row>
          <el-table v-if="isLoading" v-loading="isLoading" :data="drivers" />
          <template v-else>
            <el-row v-for="auto in drivers" :key="auto.id" :gutter="10">
              <el-col :span="17">
                <p>Водитель:</p>
                <p>
                  <b>{{ auto.fio || '(нет данных)' }}</b>
                </p>
              </el-col>
              <el-col :span="7">
                <el-button size="mini" @click="handleSelect('driver', auto)">
                  Выбрать
                </el-button>
              </el-col>
            </el-row>
            <p v-if="!drivers.length">Нет водителей доступных для выбора</p>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-button size="small" @click="clearForm">
                  Очистить форму
                </el-button>
              </el-col>
              <el-col v-if="!drivers.length" :span="12">
                <el-button
                  size="small"
                  type="primary"
                  @click="$router.push({ path: '/driver-add-mobile' })"
                >
                  Добавить водителя
                </el-button>
              </el-col>
            </el-row>
          </template>
        </section>
      </el-collapse-transition>
      <el-collapse-transition>
        <div v-if="price_selected" class="dl_price_ch">
          <p>
            Цена перевозки составит
            <template v-if="type !== 'harvest'">
              {{ day.price_from_storage_driver | getPrice }}
              <span v-if="type === 'harvest_or_delivery'">(Перевозка),</span>
            </template>
            <template v-if="type !== 'delivery'">
              {{ day.price_from_field_driver | getPrice }}
              <span v-if="type === 'harvest_or_delivery'">(Уборка)</span>
            </template>
          </p>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-button
                size="small"
                type="primary"
                :loading="loading"
                @click="createBidRequest"
              >
                Добавить отклик
              </el-button>
            </el-col>
            <el-col :span="12">
              <el-button size="small" :loading="loading" @click="clearForm">
                Очистить форму
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-collapse-transition>
    </div>
  </el-dialog>
</template>

<script>
import { GET_FILTER_DRIVERS } from '@/store/actions/drivers'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions, mapGetters } from 'vuex'

const Responses = RepositoryFactory.get('responses')

export default {
  name: 'DriverAddMobile',
  props: {
    day: {
      type: Object,
      default: () => {},
    },
    added: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selected_auto: '',
      selected_carrier_inn: '',
      selected_driver: '',
      bid_request: {
        load_day_id: this.day.id,
        automobile_id: 0,
        dispatcher_id: 0,
        driver_id: 0,
      },
      search_driver: '',
      search_auto: '',
      auto_selected: true,
      dispather_selected: false,
      price_selected: false,
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      getByKey: 'userProfile/getByKey',
      isLoading: 'drivers/getLoading',
      driversList: 'drivers/getDrivers',
      getAutos: 'autos/getAutos',
      isAutoLoading: 'autos/getAutoLoading',
    }),
    drivers() {
      return this.driversList && this.driversList.length
        ? this.driversList.filter(d => !this.added.drivers.includes(d.id))
        : []
    },
    autos() {
      return this.getAutos && this.getAutos.length
        ? this.getAutos.filter(d => !this.added.autos.includes(d.id))
        : []
    },
  },
  mounted() {
    this.fetchAutos()
  },
  methods: {
    ...mapActions('autos', ['fetchAutosNew']),
    fetchAutos(search = '') {
      this.fetchAutosNew({ org_id: this.curUserOrgId, search })
    },
    filteredAutoList() {
      if (this.search_auto.length > 2) {
        this.fetchAutos(this.search_auto)
      }
      if (this.search_auto.length === 0) {
        this.fetchAutos()
      }
    },
    filteredDriverList() {
      if (this.search_driver.length > 2) {
        this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, {
          fio: this.search_driver,
          carrier_inn: this.selected_carrier_inn,
        })
      }
      if (this.search_driver.length === 0) {
        this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, {
          carrier_inn: this.selected_carrier_inn,
        })
      }
    },
    handleSelect(param, data) {
      if (param === 'auto') {
        const { state_numbers, carrier_inn, id } = data

        this.selected_auto = state_numbers
        this.selected_carrier_inn = carrier_inn
        this.bid_request.automobile_id = id
        this.auto_selected = false
        this.dispather_selected = true
        this.search_auto = ''
        this.filteredDriverList()
      } else if (param === 'driver') {
        const { fio, dispatcher_id, id } = data

        this.selected_driver = fio
        this.bid_request.dispatcher_id = dispatcher_id
        this.bid_request.driver_id = id
        this.dispather_selected = false
        this.price_selected = true
        this.search_driver = ''
      }
    },
    createBidRequest() {
      this.loading = true
      this.bid_request.user_org_id = this.curUserOrgId
      Responses.postResponse(this.bid_request)
        .then(() => this.beforeClose(1))
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    clearForm() {
      this.selected_auto = ''
      this.selected_carrier_inn = ''
      this.selected_driver = ''
      this.bid_request = {
        load_day_id: this.day.id,
        automobile_id: 0,
        dispatcher_id: 0,
        driver_id: 0,
      }
      this.search_driver = ''
      this.search_auto = ''
      this.auto_selected = true
      this.dispather_selected = false
      this.price_selected = false
      this.filteredAutoList()
    },
    beforeClose(flag = 0) {
      this.$emit('changed', flag)
      this.clearForm()
    },
  },
}
</script>

<style lang="sass">
.app-mobile .da_mob
  .el-table
    overflow: scroll
  .classAlertError
    width: 100% !important
  section
    font-size: 12px
    .el-row
      margin-top: 15px
      display: flex
      align-items: center
      p
        margin: 0
        font-size: 14px
  .dl_price_ch
    text-align: center
    p
      margin: 20px 0
    .el-select
      margin: 20px 0
</style>
